module.exports = __webpack_public_path__ + "media/assets/create-b7f12bf88e51b026c87fbce45360bce1.svg";